import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_box_mask = _resolveComponent("text-box-mask")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": _ctx.isNewMacModalOpened,
    "no-padding": true,
    title: _ctx.$t('ICDManagement.CreateTitleMac'),
    onToggleModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_form_wrapper, { "is-form-in-modal": true }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_form_divider, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_text_box_mask, {
                    label: _ctx.$t('ICDManagement.MAC'),
                    vModel: _ctx.sensor.mac,
                    value: _ctx.sensor.mac,
                    maskRules: _ctx.rules,
                    inputAttr: {
                'aria-label': 'Mask',
                style: 'text-transform: uppercase',
              },
                    showClearButton: false,
                    errorMessage: _ctx.v$?.sensor['mac']?.$errors[0]?.$message,
                    isError: _ctx.v$?.sensor['mac']?.$error,
                    mask: "XX:XX:XX:XX:XX:XX",
                    maskInvalidMessage: "Inserted address does not match a mac address.",
                    valueChangeEvent: "keyup",
                    onValueChanged: _ctx.onValueChange
                  }, null, 8, ["label", "vModel", "value", "maskRules", "errorMessage", "isError", "onValueChanged"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-displayed", "title"]))
}